import VTooltip from 'v-tooltip';

export default { VTooltip, options: { defaultHtml: false } };
